export default __webpack_public_path__ + "static/logo-e33a56160bc47649296f4ef2649a48fe.png";